import { Component, Input, OnInit } from '@angular/core';
import { ClosableComponent } from '../../models/closable-component';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal.component.html',
  styleUrls: ['./image-modal.component.scss']
})
export class ImageModalComponent extends ClosableComponent implements OnInit {

  @Input() imgSrc: string;
  @Input() diy: string;

  constructor(public bsModalRef: BsModalRef) {
    super(bsModalRef);
  }

  ngOnInit(): void {
  }

}
